import * as React from "react";

import getGenePalette from "../getGenePalette";
import GeneSnpShapes from "../shared/GeneSnpShapes";
import { geneGroupProps } from "../shared/geneGroupProps";
import getGeneSnpCount from "../shared/getGeneSnpCount";

export const NutritionVitaminDDiagramContent = ({
  geneColors = {},
  expectedSnps = {},
  onGeneClick
}) => {
  const cyp2r1 = getGenePalette(geneColors.CYP2R1);
  const gc = getGenePalette(geneColors.GC);
  const vdr = getGenePalette(geneColors.VDR);

  return (
    <>
      <g id="diagram" clipPath="url(#clip1_18284_196598)">
        <rect width={1024} height={1344} transform="translate(0 176)" fill="white" />
        <g id="vitamin_d-diagram">
          <rect width={1024} height={1344} transform="translate(0 176)" fill="white" />
          <g id="lines">
            <g id="Frame 469">
              <text
                id="Section Divider Label"
                transform="translate(39.5 236)"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Bold"
                fontSize={24}
                letterSpacing="0em"
              >
                <tspan x={0} y={26.196}>
                  Synthesis
                </tspan>
              </text>
            </g>
          </g>
          <g id="lines_2">
            <path
              id="Vector"
              d="M41 679.5L984 679.5"
              stroke="#818181"
              strokeLinecap="round"
              strokeDasharray="8 8"
            />
            <g id="Frame 469_2">
              <text
                id="Section Divider Label_2"
                transform="translate(40.5 680)"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Bold"
                fontSize={24}
                letterSpacing="0em"
              >
                <tspan x={0} y={26.196}>
                  Activation
                </tspan>
              </text>
              <text
                id="Section Divider SubLabel"
                transform="translate(40.5 712)"
                fill="#818181"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Regular"
                fontSize={14}
                letterSpacing="0em"
              >
                <tspan x={0} y={16.76}>
                  (Liver)
                </tspan>
              </text>
            </g>
          </g>
          <g id="lines_3">
            <path
              id="Vector_2"
              d="M41 883.5L984 883.5"
              stroke="#818181"
              strokeLinecap="round"
              strokeDasharray="8 8"
            />
            <g id="Frame 469_3">
              <text
                id="Section Divider Label_3"
                transform="translate(40.5 884)"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Bold"
                fontSize={24}
                letterSpacing="0em"
              >
                <tspan x={0} y={26.196}>
                  Delivery
                </tspan>
              </text>
            </g>
          </g>
          <g id="lines_4">
            <path
              id="Vector_3"
              d="M41 1079.5L984 1079.5"
              stroke="#818181"
              strokeLinecap="round"
              strokeDasharray="8 8"
            />
            <g id="Frame 469_4">
              <text
                id="Section Divider Label_4"
                transform="translate(40.5 1080)"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Bold"
                fontSize={24}
                letterSpacing="0em"
              >
                <tspan x={0} y={26.196}>
                  Utilisation
                </tspan>
              </text>
            </g>
          </g>
          <g id="report-label">
            <g id="Report titles">
              <rect width={146} height={28} transform="translate(492 323.5)" fill="white" />
              <text
                id="25-Hydroxy Vitamin D"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Regular"
                fontSize={18}
                letterSpacing="0em"
              >
                <tspan x={492.068} y={343.62}>
                  Sunlight exposure
                </tspan>
              </text>
            </g>
            <g id="lines_5">
              <path
                id="Vector_4"
                d="M565.658 356.2L565.658 355.5L564.258 355.5L564.258 356.2L564.958 356.2L565.658 356.2ZM564.958 457.5L569 450.5L560.917 450.5L564.958 457.5ZM564.958 356.2L564.258 356.2L564.258 451.2L564.958 451.2L565.658 451.2L565.658 356.2L564.958 356.2Z"
                fill="#1A1A1A"
              />
            </g>
          </g>
          <g id="report-label_2">
            <g id="Report titles_2">
              <rect width={146} height={28} transform="translate(492 466.5)" fill="white" />
              <text
                id="25-Hydroxy Vitamin D_2"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Regular"
                fontSize={18}
                letterSpacing="0em"
              >
                <tspan x={492.007} y={486.62}>
                  Cholesterol in skin
                </tspan>
              </text>
            </g>
            <g id="lines_6">
              <path
                id="Vector_5"
                d="M565.658 499.2L565.658 498.5L564.258 498.5L564.258 499.2L564.958 499.2L565.658 499.2ZM564.958 600.5L569 593.5L560.917 593.5L564.958 600.5ZM564.958 499.2L564.258 499.2L564.258 594.2L564.958 594.2L565.658 594.2L565.658 499.2L564.958 499.2Z"
                fill="#1A1A1A"
              />
            </g>
          </g>
          <g id="report-label_3">
            <g id="Report titles_3">
              <rect width={166} height={28} transform="translate(482 609.5)" fill="white" />
              <text
                id="25-Hydroxy Vitamin D_3"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Regular"
                fontSize={18}
                letterSpacing="0em"
              >
                <tspan x={482.022} y={629.62}>
                  Vitamin D3 synthesis
                </tspan>
              </text>
            </g>
            <g id="lines_7">
              <path
                id="Vector_6"
                d="M565.658 642.2L565.658 641.5L564.258 641.5L564.258 642.2L564.958 642.2L565.658 642.2ZM564.958 743.5L569 736.5L560.917 736.5L564.958 743.5ZM564.958 642.2L564.258 642.2L564.258 737.2L564.958 737.2L565.658 737.2L565.658 642.2L564.958 642.2Z"
                fill="#1A1A1A"
              />
            </g>
          </g>
          <g id="report-label_4">
            <g id="Report titles_4">
              <rect width={146} height={28} transform="translate(491 957.5)" fill="white" />
              <text
                id="25-Hydroxy Vitamin D_4"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Regular"
                fontSize={18}
                letterSpacing="0em"
              >
                <tspan x={491.051} y={977.62}>
                  Delivery to tissues
                </tspan>
              </text>
            </g>
            <g id="lines_8">
              <path
                id="Vector_7"
                d="M564.658 990.2L564.658 989.5L563.258 989.5L563.258 990.2L563.958 990.2L564.658 990.2ZM563.958 1142.5L568 1135.5L559.917 1135.5L563.958 1142.5ZM563.958 990.2L563.258 990.2L563.258 1136.2L563.958 1136.2L564.658 1136.2L564.658 990.2L563.958 990.2Z"
                fill="#1A1A1A"
              />
            </g>
          </g>
          <g id="report-label_5">
            <g id="Report titles_5">
              <rect width={201} height={28} transform="translate(463 1151.5)" fill="white" />
              <text
                id="25-Hydroxy Vitamin D_5"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Regular"
                fontSize={18}
                letterSpacing="0em"
              >
                <tspan x={463.27} y={1171.62}>
                  Receptor binding in cells
                </tspan>
              </text>
            </g>
            <g id="lines_9">
              <path
                id="Vector_8"
                d="M564.158 1184.2L564.158 1183.5L562.758 1183.5L562.758 1184.2L563.458 1184.2L564.158 1184.2ZM563.458 1336.5L567.5 1329.5L559.417 1329.5L563.458 1336.5ZM563.458 1184.2L562.758 1184.2L562.758 1330.2L563.458 1330.2L564.158 1330.2L564.158 1184.2L563.458 1184.2Z"
                fill="#1A1A1A"
              />
            </g>
          </g>
          <g id="report-label_6">
            <g id="Report titles_6">
              <rect width={182} height={56} transform="translate(473 752.5)" fill="white" />
              <text
                id="25-Hydroxy Vitamin D_6"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Bold"
                fontSize={18}
                letterSpacing="0em"
              >
                <tspan x={473.402} y={772.647}>
                  25-Hydroxy Vitamin D
                </tspan>
              </text>
              <text
                id="Sub Label"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Regular"
                fontSize={16}
                letterSpacing="0em"
              >
                <tspan x={527.633} y={799.94}>
                  Sub Label
                </tspan>
              </text>
            </g>
            <g id="lines_10">
              <path
                id="Vector_9"
                d="M564.658 813.2L564.658 812.5L563.258 812.5L563.258 813.2L563.958 813.2L564.658 813.2ZM563.958 948.5L568 941.5L559.917 941.5L563.958 948.5ZM563.958 813.2L563.258 813.2L563.258 942.2L563.958 942.2L564.658 942.2L564.658 813.2L563.958 813.2Z"
                fill="#1A1A1A"
              />
            </g>
          </g>
          <g id="Report titles_7">
            <rect width={137} height={56} transform="translate(492 1345.5)" fill="white" />
            <text
              id="25-Hydroxy Vitamin D_7"
              fill="#1A1A1A"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Regular"
              fontSize={18}
              letterSpacing="0em"
            >
              <tspan x={508.442} y={1365.62}>
                Bone health{" "}
              </tspan>
              <tspan x={492.033} y={1393.62}>
                Immune function
              </tspan>
            </text>
          </g>
          <g id="Report titles_8">
            <rect width={94} height={20} transform="translate(329.5 958)" fill="white" />
            <text
              id="25-Hydroxy Vitamin D_8"
              fill="#1A1A1A"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Regular"
              fontSize={12}
              letterSpacing="0px"
            >
              <tspan x={329.689} y={972.08}>
                Transport protein
              </tspan>
            </text>
          </g>
          <g id="gene-CYP2R1" {...geneGroupProps("CYP2R1", onGeneClick)}>
            <g id="gene-lozenge_5">
              <path
                d="M330.5 693C330.5 690.791 332.291 689 334.5 689H439.5C441.709 689 443.5 690.791 443.5 693V729C443.5 731.209 441.709 733 439.5 733H334.5C332.291 733 330.5 731.209 330.5 729V693Z"
                fill={cyp2r1.lozengeFill}
              />
              <text
                id="gene-label_5"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Regular"
                fontSize={24}
                letterSpacing="0em"
              >
                <tspan x={346.547} y={719.16}>
                  CYP2R1
                </tspan>
              </text>
            </g>
            <GeneSnpShapes
              id="cyp2r1"
              groupId="gene-snps"
              genePalette={cyp2r1}
              startX={338.5}
              startY={735}
              snpCount={getGeneSnpCount("CYP2R1", expectedSnps, geneColors)}
            />
          </g>
          <g id="gene-GC" {...geneGroupProps("GC", onGeneClick)}>
            <g id="gene-lozenge_6">
              <path
                d="M330.5 898C330.5 895.791 332.291 894 334.5 894H426.5C428.709 894 430.5 895.791 430.5 898V934C430.5 936.209 428.709 938 426.5 938H334.5C332.291 938 330.5 936.209 330.5 934V898Z"
                fill={gc.lozengeFill}
              />
              <text
                id="gene-label_6"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Regular"
                fontSize={24}
                letterSpacing="0em"
              >
                <tspan x={362.09} y={924.16}>
                  GC
                </tspan>
              </text>
            </g>
            <GeneSnpShapes
              id="gc"
              groupId="gene-snps_2"
              genePalette={gc}
              startX={338.5}
              startY={940}
              snpCount={getGeneSnpCount("GC", expectedSnps, geneColors)}
            />
          </g>
          <g id="gene-VDR" {...geneGroupProps("VDR", onGeneClick)}>
            <g id="gene-lozenge_7">
              <path
                d="M330.5 1093C330.5 1090.79 332.291 1089 334.5 1089H426.5C428.709 1089 430.5 1090.79 430.5 1093V1129C430.5 1131.21 428.709 1133 426.5 1133H334.5C332.291 1133 330.5 1131.21 330.5 1129V1093Z"
                fill={vdr.lozengeFill}
              />
              <text
                id="gene-label_7"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Regular"
                fontSize={24}
                letterSpacing="0em"
              >
                <tspan x={357.238} y={1119.16}>
                  VDR
                </tspan>
              </text>
            </g>
            <GeneSnpShapes
              id="vdr"
              groupId="gene-snps_3"
              genePalette={vdr}
              startX={338.5}
              startY={1135}
              snpCount={getGeneSnpCount("VDR", expectedSnps, geneColors)}
            />
          </g>
        </g>
      </g>
    </>
  );
};

const SvgNutritionVitaminDDiagram = ({
  geneColors = {},
  expectedSnps = {},
  onGeneClick,
  ...props
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={1024}
    height={1344}
    viewBox="0 176 1024 1344"
    fill="none"
    {...props}
  >
    <NutritionVitaminDDiagramContent
      geneColors={geneColors}
      expectedSnps={expectedSnps}
      onGeneClick={onGeneClick}
    />
    <defs>
      <clipPath id="clip0_18284_196598">
        <rect width={1024} height={1488} fill="white" />
      </clipPath>
      <clipPath id="clip1_18284_196598">
        <rect width={1024} height={1344} fill="white" transform="translate(0 176)" />
      </clipPath>
    </defs>
  </svg>
);

export default SvgNutritionVitaminDDiagram;
